"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectAllButton = void 0;
var _react = require("react");
var _styles = require("@mui/styles");
var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));
var _Option = _interopRequireDefault(require("../Option"));
var _Checkbox = _interopRequireDefault(require("../../Checkbox"));
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    listControl: {
      height: function height(_ref) {
        var rowHeight = _ref.rowHeight;
        return "".concat(rowHeight, "px");
      },
      cursor: 'pointer',
      '& > .MuiFormControl-root': {
        width: '100%'
      },
      '& span': {
        color: theme.palette.primary.main,
        fontWeight: 500,
        wordSpacing: '1px',
        letterSpacing: '1.25px',
        textTransform: 'uppercase'
      }
    },
    selectAllLabel: {
      margin: 0
    }
  };
});
var SelectAllButton = exports.SelectAllButton = function SelectAllButton(_ref2) {
  var _ref2$focusableSelect = _ref2.focusableSelectedOptions,
    focusableSelectedOptions = _ref2$focusableSelect === void 0 ? [] : _ref2$focusableSelect,
    _ref2$focusableOption = _ref2.focusableOptions,
    focusableOptions = _ref2$focusableOption === void 0 ? [] : _ref2$focusableOption,
    _ref2$selectedOptions = _ref2.selectedOptions,
    selectedOptions = _ref2$selectedOptions === void 0 ? [] : _ref2$selectedOptions,
    onChange = _ref2.onChange,
    limitOverflow = _ref2.limitOverflow,
    getOptionValue = _ref2.getOptionValue,
    count = _ref2.count;
  var classes = useStyles();
  var allSelected = (0, _react.useMemo)(function () {
    return focusableSelectedOptions.length === focusableOptions.length;
  }, [focusableSelectedOptions, focusableOptions]);
  var partialSelected = (0, _react.useMemo)(function () {
    return !allSelected && focusableSelectedOptions.length > 0;
  }, [focusableSelectedOptions, allSelected]);
  var handleToggleAll = (0, _react.useCallback)(function (_e) {
    var focusableOptionsIds = (focusableOptions === null || focusableOptions === void 0 ? void 0 : focusableOptions.map(getOptionValue)) || [];
    if (allSelected) {
      onChange(selectedOptions.filter(function (opt) {
        return !focusableOptionsIds.includes(getOptionValue(opt));
      }));
    } else {
      onChange((0, _uniqBy["default"])([].concat(_toConsumableArray(selectedOptions), _toConsumableArray(focusableOptions)), getOptionValue));
    }
  }, [onChange, allSelected, selectedOptions, focusableOptions]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Option["default"], {
    className: classes.listControl,
    isButton: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox["default"], {
      label: "Select All ".concat(count),
      color: 'primary',
      edge: 'start',
      "data-cy-role": _constants.dataCyRoleSelectAllCheckbox,
      indeterminate: partialSelected,
      checked: allSelected,
      LabelProps: {
        classes: {
          root: classes.selectAllLabel
        }
      },
      onClick: handleToggleAll,
      "data-cy-action": _constants.dataCyActionSelectAll,
      disabled: limitOverflow
    })
  });
};